<span [ngClass]="cssClass" [matTooltip]="showTooltip && needsTooltip ? fullName : ''"
    [matTooltipDisabled]="!showTooltip || !needsTooltip" [matTooltipPosition]="'above'"
    [matTooltipClass]="'job-role-tooltip'">
    {{ displayName }}
</span>